// extracted by mini-css-extract-plugin
export var links = "Nav-module--links--SXsRJ";
export var logo = "Nav-module--logo--Gy5Ss";